import { Link, useLocation } from 'react-router-dom';
import {
  Alert,
  Button,
  Text,
  TextLink
} from '@teachstonellc/component-library';
import MainContent from 'components/MainContent';
import errorMarkerImg from 'images/error_marker.svg';
import i18n from 'helpers/i18n';
import messages from './messages';

type ForbiddenLocationState = {
  errorMessage?: string;
};

function Forbidden() {
  const location = useLocation();
  const errorMessage = (location.state as ForbiddenLocationState | null)
    ?.errorMessage;

  return (
    <MainContent maxWidth={1024}>
      <div className="mx-auto flex text-ds-text-primary py-8 px-4 sm:p-8 md:px-8 md:py-16 md:items-start md:gap-4 lg:py-32">
        <img
          alt=""
          src={errorMarkerImg}
          className="hidden w-full max-w-48 md:block"
        />

        <div>
          <Text variant="h1">
            <span className="text-ds-blue-9">{i18n.ft(messages.snap)}</span>
            &nbsp;
            {i18n.ft(messages.capsOff)}
            <br />
            {i18n.ft(messages.cannotDrawn)}
          </Text>

          <div className="my-6 flex flex-col gap-2">
            <Text as="p" variant="body1">
              <strong>{i18n.ft(messages.ourApologies)}</strong>
            </Text>
            <Alert
              variant="negative"
              role="alert"
              title={i18n.ft(messages.forbiddenPath)}
              description={errorMessage}
            />
          </div>

          <Link to="/">
            <Button>{i18n.ft(messages.goToDashboard)}</Button>
          </Link>

          <div className="mt-8">
            <Text as="p" variant="body1">
              {i18n.ft(messages.needHelp) + ' '}
              <TextLink href="https://teachstone.com/contact/?q=/about-teachstone/contact-us">
                {i18n.ft(messages.contactUs)}
              </TextLink>
            </Text>
            <Text as="p" variant="body1">
              {i18n.ft(messages.emailUs) + ' '}
              <TextLink href="mailto:contact@teachstone.com">
                contact@teachstone.com
              </TextLink>
            </Text>
          </div>
        </div>
      </div>
    </MainContent>
  );
}

export default Forbidden;
